import axios from 'axios';

import { config } from '../config';

export const FunnelApiClient = axios.create({
  baseURL: `${config.api.baseUrl}/api`,
});

FunnelApiClient.interceptors.response.use((req) => req.data);
